import React from 'react';

// mui
import { Box } from '@mui/material';

// components
import { AccountFiltersFilters } from '../..';

function AccountFilters(props) {
    return (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <AccountFiltersFilters {...props} />
        </Box>
    );
}

export { AccountFilters };
